import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {MeterFlowVolume, MeterFlowVolumeEntity} from "../../../model/meter-flow-volume";
import {
  MeterFlowVolumeTotal,
  MeterFlowVolumeTotalEntity,
  TemporalMeterFlowVolumeTotalMatrix
} from "../../../model/meter-flow-volume-total";

export interface MeterFlowVolumeSelectorProps {
  regionId?: string
}

const getRegionIdParam = createParamSelector<MeterFlowVolumeSelectorProps | undefined, string | undefined>(params => params?.regionId);

export const meterFlowVolumesSelector = () => createSelector(
  [getUseQueryResultData<MeterFlowVolume[]>, getRegionIdParam],
  (data, regionId) => {
    return selectMeterFlowVolumesAndTransform(
      data ?? [], {
        regionId: regionId,
      }
    );
  }
);

export const meterFlowVolumeSelector = () => createSelector(
  [getUseQueryResultData<MeterFlowVolume>],
  (data) => {
    return data ? transformMeterFlowVolume(data) : undefined;
  }
);

export const selectMeterFlowVolumes = (values?: MeterFlowVolume[], selector?: MeterFlowVolumeSelectorProps): MeterFlowVolume[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (v.regionId !== selector.regionId) {
        filterIn = false;
      }
    }

    return filterIn;
  });
};

export const transformMeterFlowVolume = (value: MeterFlowVolume): MeterFlowVolumeEntity => {
  return MeterFlowVolumeEntity.from(value)
}

export const selectMeterFlowVolumesAndTransform = (values?: MeterFlowVolume[], selector?: MeterFlowVolumeSelectorProps): MeterFlowVolumeEntity[] => {
  const selected = selectMeterFlowVolumes(values, selector);
  return selected.map(transformMeterFlowVolume);
};

export interface MeterFlowVolumeTotalSelectorProps {
  regionId?: string
}

const getMeterFlowVolumeRegionIdParam = createParamSelector<MeterFlowVolumeTotalSelectorProps | undefined, string | undefined>(params => params?.regionId);

export const meterFlowVolumeTotalsSelector = () => createSelector(
  [getUseQueryResultData<MeterFlowVolumeTotal[]>, getMeterFlowVolumeRegionIdParam],
  (data, regionId) => {
    return selectMeterFlowVolumeTotalsAndTransform(
      data ?? [], {
        regionId: regionId,
      }
    );
  }
);

export const meterFlowVolumeTotalSelector = () => createSelector(
  [getUseQueryResultData<MeterFlowVolumeTotal>],
  (data) => {
    return data ? transformMeterFlowVolumeTotal(data) : undefined;
  }
);

export const selectMeterFlowVolumeTotals = (values?: MeterFlowVolumeTotal[], selector?: MeterFlowVolumeTotalSelectorProps): MeterFlowVolumeTotal[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (v.regionId !== selector.regionId) {
        filterIn = false;
      }
    }

    return filterIn;
  });
};

export const transformMeterFlowVolumeTotal = (value: MeterFlowVolumeTotal): MeterFlowVolumeTotalEntity => {
  return MeterFlowVolumeTotalEntity.from(value)
}

export const selectMeterFlowVolumeTotalsAndTransform = (values?: MeterFlowVolumeTotal[], selector?: MeterFlowVolumeTotalSelectorProps): MeterFlowVolumeTotalEntity[] => {
  const selected = selectMeterFlowVolumeTotals(values, selector);
  return selected.map(transformMeterFlowVolumeTotal);
};

export const meterFlowVolumeTotalMatrixSelector = () => createSelector(
  [getUseQueryResultData<TemporalMeterFlowVolumeTotalMatrix>],
  (data) => {
    return data;
  }
);
